// extracted by mini-css-extract-plugin
export default {"container":"O_SD_","title":"MfOzp","paid":"hVnBt","link":"LnznN"};